import { Responses } from './types'
import request from '@/helper/superagent-protected'
import store from '@/store'

export async function searchSupply(supply: string): Promise<Responses.ISupplyResponse[]> {
  const apiUrl = store.getters.parameters('apiUrl')

  return request
    .get(`${apiUrl}/v0/suppliers/search?q=${supply}`)
    .then((res: any) => res.body)
}
